


export const formateDate = (date) => {
    const arr = date.split('T')[0].split('-')
    const day = arr[2]
    const month = arr[1]
    const year = arr[0]
    return `${day}.${month}.${year}`
}

const addZeroHandler = (_time) => {
    const time = _time.toString()
    if (time.length === 1) {
        return `0${time}`
    }
    return time
}

export function formatIsoToDateNew(_date) {
    return _date.slice(8, 10) + '.' + _date.slice(5, 7) + '.' + _date.slice(0, 4)
}

export function formatIsoToTime(_date) {
    const hours = _date.slice(11, 13)
    const minutes = _date.slice(14, 16)
    const seconds = _date.slice(17, 19)
    return addZeroHandler(+hours) + ':' + addZeroHandler(+minutes) + ':' + addZeroHandler(+seconds)
}
